<template>
  <b-container class="px-0">
    <b-row>
      <b-col cols="9">
        <router-link :to="`/user/${review.user.uuid}`">
          <img
            class="rounded-circle img-profile mr-2"
            :src="review.user.avatar"
            :alt="`${review.user.first_name} ${review.user.last_name}`"
          />
          {{ review.user.first_name }} {{ review.user.last_name }}
        </router-link>
      </b-col>
      <b-col>
          <p>{{ review.rating }}/5</p>
      </b-col>
    </b-row>
    <b-row>
        <b-col>
            <p>{{ review.notes }}</p>
        </b-col>
    </b-row>
  </b-container>
</template>
<script>
export default {
  name: 'EducationalItemReview',
  props: {
    review: Object,
  },
  data() {
    return {}
  },
}
</script>

<style scoped>
.img-profile {
  width: 24px;
  height: 24px;
}
</style>
